<div class="d-flex">
	<div class="h3">
		<span *ngIf="dealerService.dealer.value.name">Welcome {{ dealerService.dealer.value.name }}</span>
	</div>
	<div class="ms-auto" *ngIf="userService.user?.role >= 5 && selectedDealerKey">
		<span class="p-float-label">
			<p-dropdown
				#dealerList
				[options]="dealerService.dealerList.value"
				optionLabel="name"
				optionValue="key"
				name="dealerList"
				[(ngModel)]="selectedDealerKey"
				(onChange)="dealerService.initDealer(selectedDealerKey)"
				[style]="{ width: '100%' }"
				appendTo="body"
				[autoDisplayFirst]="false"
				[virtualScroll]="true"
				virtualScrollItemSize="30"
				filter="true"
				filterBy="name"
			></p-dropdown>
			<label for="dealerList">Dealer</label>
		</span>
	</div>
</div>

<app-dealer-dashboard></app-dealer-dashboard>

<app-dealer-venue-list-view [(venueSelected)]="venueSelected"></app-dealer-venue-list-view>

<app-dealer-venue-tools *ngIf="venueSelected" [(venueSelected)]="venueSelected"></app-dealer-venue-tools>

<p-dialog *ngIf="dealerService.dealerList" [(visible)]="displayDealerSelect" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '50vw' }">
	<ng-template pTemplate="header">
		<fa-icon [icon]="['far', 'building']" class="me-4" size="lg"></fa-icon>
		<div class="h4">Select a Dealer</div>
	</ng-template>

	<div class="d-flex">
		<div class="mt-4 w-100">
			<span class="p-float-label">
				<p-dropdown
					#dealerList
					[options]="dealerService.dealerList.value"
					optionLabel="name"
					optionValue="key"
					name="dealerList"
					[(ngModel)]="selectedDealerKey"
					[style]="{ width: '100%' }"
					appendTo="body"
					[autoDisplayFirst]="false"
					[virtualScroll]="true"
					virtualScrollItemSize="30"
					filter="true"
					filterBy="name"
				></p-dropdown>
				<label for="dealerList">Dealer</label>
			</span>
		</div>
	</div>

	<ng-template pTemplate="footer">
		<app-record-control-footer
			[hideCancel]=""
			[hideDelete]="true"
			[hideSave]=""
			saveLabel="Select"
			(onCancelChange)="displayDealerSelect = false"
			(onSaveChange)="dealerService.initDealer(selectedDealerKey); displayDealerSelect = false"
			[cancelDisabled]=""
			[saveDisabled]="!selectedDealerKey"
		></app-record-control-footer>
	</ng-template>
</p-dialog>
